import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    marginBottom: 0,
  },
  label: {},
  switchBase: {
    color: palette.switch.color,
    '&$checked': {
      color: palette.menuAction.selected,
    },
    '&$checked + $track': {
      backgroundColor: palette.menuAction.selected,
    },
  },
  checked: {},
  track: palette.switch.track,
  topLabel: {
    fontWeight: 700,
    fontFamily: 'Montserrat',
  },
}), { name: 'FormSwitch' });

export default useStyles;
